export function getCurrency(currency) {
  if (!currency) return "£";
  else return currency;
}
